import {
  getLocalStorageItem,
  setLocalStorageItem,
  removeLocalStorageItem,
  setRawLocalStorageItem,
  getRawLocalStorageItem,
} from "@shared-ui/utils/localStorage";

const STORAGE_KEY = "Cognito.rememberMe";
const LAST_LOGIN_ID_KEY = "Portal.lastLoginId";

interface RememberMeData {
  rememberMe: boolean;
}

export const setRememberMeToStorage = (rememberMe: boolean): void => {
  setLocalStorageItem<RememberMeData>(STORAGE_KEY, { rememberMe });
};

export const getRememberMeFromStorage = (): boolean => {
  return getLocalStorageItem<RememberMeData>(STORAGE_KEY, { rememberMe: false }).rememberMe;
};

export const clearRememberMeFromStorage = (): void => {
  removeLocalStorageItem(STORAGE_KEY);
};

export const setLastLoginId = (email: string): void => {
  setRawLocalStorageItem(LAST_LOGIN_ID_KEY, email);
};

export const getLastLoginId = (): string | null => {
  const value = getRawLocalStorageItem(LAST_LOGIN_ID_KEY, "");
  return value || null;
};

/**
 * PRODUCT_DEV-484 エイリアスログイン由来セッションの戻り先 tenantId。
 * sessionStorage に保持（タブを閉じると消える）。エイリアスURL (`/<tenantId>`) から
 * ポータルに入った場合、ポータル内のどの画面でログアウトしても
 * エイリアスログイン画面へ戻すために使う。
 */
const ALIAS_RETURN_TENANT_KEY = "Portal.aliasReturnTenant";

export const setAliasReturnTenant = (tenantId: string): void => {
  try {
    sessionStorage.setItem(ALIAS_RETURN_TENANT_KEY, tenantId);
  } catch {
    // ignore (sessionStorage 不可環境)
  }
};

export const getAliasReturnTenant = (): string | null => {
  try {
    return sessionStorage.getItem(ALIAS_RETURN_TENANT_KEY) || null;
  } catch {
    return null;
  }
};
